var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.174,
    height: 41.058,
    viewBox: "0 0 39.174 41.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1429",
    "data-name": "Tracciato 1429",
    d: "M25.78,6.75a7.345,7.345,0,1,1,0,3.39h-9.8a5.841,5.841,0,0,0-5.656,4.385,7.347,7.347,0,0,1,0,14.206,5.841,5.841,0,0,0,5.656,4.386h9.8a7.345,7.345,0,1,1,0,3.39h-9.8a9.231,9.231,0,0,1-9.1-7.7,7.347,7.347,0,0,1,0-14.354,9.231,9.231,0,0,1,9.1-7.7Zm7.149-2.26a3.955,3.955,0,1,0,3.955,3.955A3.955,3.955,0,0,0,32.928,4.49ZM8.445,17.673A3.955,3.955,0,1,0,12.4,21.628,3.955,3.955,0,0,0,8.445,17.673ZM28.973,34.812a3.955,3.955,0,1,1,3.955,3.955A3.955,3.955,0,0,1,28.973,34.812Z",
    transform: "translate(-1.1 -1.1)",
    fill: "#14bf96",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLink);
export default __webpack_public_path__ + "static/media/social-link.83638823d0c30f47dc72c57b19f71700.svg";
export { ForwardRef as ReactComponent };